import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'src/store/app/types';

const setEditorCapabilitiesReducer = (state: AppState, action: PayloadAction<string[]>) => {
  state.editorCapabilities = action.payload;
};

export default setEditorCapabilitiesReducer;
